import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdFileDownload } from 'react-icons/md';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import FooterButtons from 'components/shared/FooterButtons';
import { deepDiver } from 'helpers/utilities';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import TabbedPanel from 'components/shared/TabbedPanel';
import NoticeDeliveryReport from './NoticeDeliveryReport';
import NoticeForm from './NoticeForm';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { getTranslatedString } from 'helpers/i18n';

const PARTIALLY_DELIVERED = 'Partially Delivered';
const DELIVERED = 'Delivered';
const EXPIRED = 'Expired';

const styles = {
  tabBodyWrapper: {
    padding: '15px',
    paddingBottom: '75px',
    marginBottom: '50px',
  },
  card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '15px',
  },
  tabbedHeaderWrapper: {
    width: '100%',
    padding: '10px',
    height: '48px',
    backgroundColor: '#efefef',
  },
  tabbedHeader: {
    textAlign: 'center',
    margin: '8px 0',
  },
};
const wStyles = (theme) => ({
  btnRoot: {
    marginLeft: '5px',
    color: '#3383ee',
    border: '2px solid #3383ee',
    '&:hover': {
      border: '2px solid #3383ee',
      backgroundColor: 'rgba(51, 131, 238, 0.1)',
    },
  },
});

const NOTICE_FORM_NAME = 'notice_form';

class NoticeDetailsOverview extends Component {
  state = {
    showConfirmationDialog: false,
  };

  updateNotice = (formData) => {
    this.props.updateNotice(formData);
  };

  toggleConfirmationDialog = () => {
    this.setState({
      showConfirmationDialog: !this.state.showConfirmationDialog,
    });
  };

  render() {
    const readOnly = hostIsBoardwalk() === true;
    const tabHeaders = [getTranslatedString('landlordPortal.noticeDetailsOverview.details')];
    const tabBodies = [this.renderDetailsBody(readOnly)];
    const tabFooters = [this.renderDetailsFooter()];

    if ([DELIVERED, PARTIALLY_DELIVERED, EXPIRED].includes(this.props.notice.status)) {
      tabHeaders.push(getTranslatedString('landlordPortal.noticeDetailsOverview.deliveryReport'));
      tabBodies.push(this.renderDeliveryReportBody());
      tabFooters.push(this.renderCloseOnlyFooter());
    }

    return (
      <Fragment>
        <div className="row" style={styles.tabbedHeaderWrapper}>
          <h3 style={styles.tabbedHeader}>
            {(this.props.noticeFormData && this.props.noticeFormData.name) ||
              this.props.notice.name}
          </h3>
        </div>

        <TabbedPanel tabHeaders={tabHeaders} tabBodies={tabBodies} tabFooters={tabFooters} />
      </Fragment>
    );
  }

  renderDetailsBody = (readOnly) => {
    return (
      <div style={styles.tabBodyWrapper}>
        <Card style={styles.card}>
          <NoticeForm
            formName={NOTICE_FORM_NAME}
            noticeTemplates={this.props.noticeTemplates}
            properties={this.props.properties}
            onSubmit={this.updateNotice}
            initialValues={this.props.notice}
            readOnly={readOnly}
            isNoticeDrawer={this.props.isNoticeDrawer}
          />
        </Card>
        <div style={{ textAlign: 'center', paddingBottom: '10px' }}>
          {!readOnly && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.toggleConfirmationDialog}
              style={{ borderWidth: '2px' }}
            >
              {getTranslatedString('landlordPortal.noticeDetailsOverview.deactivate')}{' '}
              <DeleteIcon style={{ fontSize: '21px', marginLeft: '8px' }} />
            </Button>
          )}
          <Button
            color="primary"
            variant="outlined"
            onClick={() => this.props.downloadGenericPdf(this.props.notice.id)}
            classes={{ root: this.props.classes.btnRoot }}
          >
            {getTranslatedString('landlordPortal.noticeDetailsOverview.genericPdf')}{' '}
            <MdFileDownload style={{ fontSize: '21px', marginLeft: '8px' }} />
          </Button>
        </div>
        <ConfirmationDialog
          showDialog={this.state.showConfirmationDialog}
          hideDialog={this.toggleConfirmationDialog}
          userConfirmVerbiage={getTranslatedString(
            'landlordPortal.noticeDetailsOverview.deactivate'
          )}
          userConfirmAction={this.props.deleteNotice}
          dialogTitle={getTranslatedString('landlordPortal.noticeDetailsOverview.areYouSure')}
          dialogBodyVerbiage={getTranslatedString(
            'landlordPortal.noticeDetailsOverview.areYouSureCannotBeUndoneDeactivate'
          )}
        />
      </div>
    );
  };

  renderDetailsFooter = () => {
    return (
      <FooterButtons
        backName={getTranslatedString('landlordPortal.noticeDetailsOverview.close')}
        backAction={this.props.toggleDrawer}
        formName={NOTICE_FORM_NAME}
        submitName={getTranslatedString('landlordPortal.noticeDetailsOverview.save')}
      />
    );
  };

  renderDeliveryReportBody = () => {
    return (
      <div style={styles.tabBodyWrapper}>
        <Card>
          <NoticeDeliveryReport
            properties={this.props.notice.properties || []}
            report={this.props.deliveryReport}
            downloadTargetedPdf={(porpertyIds) =>
              this.props.downloadTargetedPdf(this.props.notice.id, porpertyIds)
            }
          />
        </Card>
      </div>
    );
  };

  renderCloseOnlyFooter = () => {
    return (
      <FooterButtons
        hideSubmitButton
        backName={getTranslatedString('landlordPortal.noticeDetailsOverview.close')}
        backAction={this.props.toggleDrawer}
      />
    );
  };
}

const ConnectedNoticeDetailsOverview = connect((store) => ({
  noticeFormData: deepDiver(store, `form.${NOTICE_FORM_NAME}.values`),
}))(NoticeDetailsOverview);

export default withStyles(wStyles)(ConnectedNoticeDetailsOverview);
